import { useState, forwardRef } from "react";
import { cn } from "../../lib/utils";

/**
 * Özel Input bileşeni
 * @param {Object} props - Bileşen özellikleri
 * @returns {JSX.Element} - Input bileşeni
 */
const Input = forwardRef((props, ref) => {
  const {
    id,
    type = "text",
    value,
    onChange,
    placeholder,
    className,
    isValid = true,
    labelId,
    labelname,
    classes,
    symbol: Icon,
    InpName,
    left,
    ...otherProps
  } = props;

  const [condition, setCondition] = useState("inactive");
  
  const handleOnFocus = () => {
    setCondition("active");
  };

  const handleOnBlur = () => {
    setCondition("inactive");
  };

  // Input bileşeni farklı şekillerde kullanılabiliyor, bu yüzden hem normal input olarak
  // hem de özel stil ve işlevsellikle kullanılabilmesini sağlayalım
  if (labelId && labelname) {
    // Özel stil ve işlevsellik ile kullanım
    const inputType = labelId === "password" ? "password" : type || "text";

    return (
      <div className={`${classes} text-sm font-semibold text-gray-500 flex flex-col gap-1`}>
        <label htmlFor={labelId}>{labelname}</label>
        <div className={`relative`}>
          {left ? (
            <>
              <div
                className={cn(
                  "font-black rounded-l-sm absolute h-full p-2 flex items-center justify-center bg-[#e3f4fc]",
                  !isValid ? "bg-red-600 text-white" : condition === "active" ? "bg-[#0090e1] text-white" : "bg-[#e3f4fc]"
                )}
              >
                {Icon ? <Icon className="h-4 w-4" /> : <>{InpName}</>}
              </div>
              <input
                value={value}
                onChange={onChange}
                onFocus={handleOnFocus}
                onBlur={handleOnBlur}
                placeholder={placeholder}
                className={cn(
                  "cursor-pointer font-bold text-black pl-10 py-2 pr-2 w-full ring-1 outline-none rounded-sm",
                  !isValid ? "ring-red-600" : condition === "active" ? "ring-[#0090e1]" : cn("ring-slate-400")
                )}
                id={labelId}
                type={inputType}
                ref={ref}
                {...otherProps}
              />
            </>
          ) : (
            <>
              <input
                value={value}
                onChange={onChange}
                onFocus={handleOnFocus}
                onBlur={handleOnBlur}
                placeholder={placeholder}
                className={cn(
                  "cursor-pointer font-bold text-black p-2 w-full ring-1 outline-none rounded-sm",
                  !isValid ? "ring-red-600" : condition === "active" ? "ring-[#0090e1]" : cn("ring-slate-400")
                )}
                id={labelId} 
                type={inputType}
                ref={ref}
                {...otherProps}
              />
              <div className={cn(
                "top-0 right-0 absolute font-bold rounded-r-sm h-full p-2 flex items-center justify-center",
                !isValid ? "bg-red-600 text-white" : condition === "active" ? "bg-[#0090e1] text-white" : "bg-[#e3f4fc]"
              )}>
                {Icon ? <Icon className="h-4 w-4" /> : <>{InpName}</>}
              </div>
            </>
          )}
        </div>
        {!isValid && (
          <div className="text-red-500 text-xs font-semibold">
            Bu alan gereklidir!
          </div>
        )}
      </div>
    );
  }

  // Normal input olarak kullanım (Shadcn'nin Input bileşeni gibi)
  return (
    <input
      id={id}
      type={type}
      value={value}
      onChange={onChange}
      placeholder={placeholder}
      className={cn(
        "flex h-9 w-full rounded-md border border-input bg-transparent px-3 py-1 text-sm shadow-sm transition-colors file:border-0 file:bg-transparent file:text-sm file:font-medium placeholder:text-muted-foreground focus-visible:outline-none focus-visible:ring-1 focus-visible:ring-ring disabled:cursor-not-allowed disabled:opacity-50",
        className
      )}
      ref={ref}
      {...otherProps}
    />
  );
});

Input.displayName = "Input";

export { Input };
